import { Download, X } from 'lucide-react';
import { Modal } from '../ui/Modal';
import type { MediaCategory, MediaItem } from './MediaConfig';

interface Props {
  media: MediaItem | null;
  onClose: () => void;
  categories: MediaCategory[];
  onSendToComunicado?: (m: MediaItem) => void;
}

export function MediaViewModal({ media, onClose, categories, onSendToComunicado }: Props) {
  if (!media) return null;

  const cat = categories.find((c) => c.id === media.categoria) || {
    id: 'OUTRO',
    label: 'Outros',
    color: '#6b7280',
  };

  const handleDownload = () => {
    const a = document.createElement('a');
    a.href = media.arquivoUrl;
    a.download = `${media.titulo || 'midia'}.${media.tipoArquivo === 'PDF' ? 'pdf' : 'jpg'}`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  return (
    <Modal
      open={!!media}
      onClose={onClose}
      title={media.titulo}
      size="lg"
      footer={
        <>
          <button type="button" className="btn-cancel" onClick={handleDownload} style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
            <Download size={14} /> Baixar Arquivo
          </button>
          <div style={{ flex: 1 }} />
          {onSendToComunicado && (
            <button
              type="button"
              className="btn-save"
              style={{ background: '#2563eb' }}
              onClick={() => {
                onClose();
                onSendToComunicado(media);
              }}
            >
              Criar Comunicado com este Folder
            </button>
          )}
          <button type="button" className="btn-cancel" onClick={onClose}>
            Fechar
          </button>
        </>
      }
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 14 }}>
        <div style={{ alignSelf: 'flex-start', display: 'inline-flex', alignItems: 'center', gap: 6, padding: '3px 10px', borderRadius: 6, background: `${cat.color}15`, color: cat.color, fontSize: '.74rem', fontWeight: 700 }}>
          {cat.label}
        </div>

        {media.tipoArquivo === 'PDF' ? (
          <iframe
            src={media.arquivoUrl}
            title={media.titulo}
            style={{ width: '100%', height: '55vh', border: '1px solid var(--border-color)', borderRadius: 8 }}
          />
        ) : (
          <img
            src={media.arquivoUrl}
            alt={media.titulo}
            style={{
              maxWidth: '100%',
              maxHeight: '60vh',
              objectFit: 'contain',
              borderRadius: 10,
              boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
            }}
          />
        )}

        {media.descricao && (
          <p style={{ margin: '8px 0 0', fontSize: '.84rem', color: 'var(--text-muted)', textAlign: 'center', lineHeight: 1.5 }}>
            {media.descricao}
          </p>
        )}
      </div>
    </Modal>
  );
}
